import { STRINGS } from '../../constants';
import apiCaller from '../http';

export const fetchMoreVisitsForDate = async (
  url,
  value,
  setError,
  saveMoreVisits,
  logoutHandler,
) => {
  const now = new Date();
  const today = new Date(now.getFullYear(), now.getMonth(), now.getDate());
  const payload = {
    day: value?.day ?? today.getDate(),
    month: (value?.month ?? today.getMonth()) + 1,
    year: value?.year ?? today.getFullYear(),
  };

  const noHostUrl = url?.split('://')[1];
  const correctUrl = noHostUrl?.substring(noHostUrl?.indexOf('/'));
  await apiCaller
    .get(correctUrl, {
      params: payload,
    })
    .then((response) => {
      if (response.data !== undefined) {
        setError(null);
        saveMoreVisits(response.data);
      } else {
        setError(STRINGS.common.error404Text);
      }
    })
    .catch((e) => {
      if (e.message === STRINGS.common.errorMissingCredentials) {
        logoutHandler();
      }
      if (e.message === STRINGS.common.error400Template) {
        setError(STRINGS.common.error400TextRead);
      }
      setError(STRINGS.common.error404Text);
    });
};

export const fetchMoreVisitsOngoing = async (
  url,
  setError,
  saveMoreVisits,
  logoutHandler,
  token,
) => {
  const noHostUrl = url?.split('://')[1];
  const correctUrl = noHostUrl?.substring(noHostUrl?.indexOf('/'));
  await apiCaller
    .get(correctUrl, {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    })
    .then((response) => {
      if (response.data !== undefined) {
        setError(null);
        saveMoreVisits(response.data);
      } else {
        setError(STRINGS.common.error404Text);
      }
    })
    .catch((e) => {
      if (e.message === STRINGS.common.errorMissingCredentials) {
        logoutHandler();
      }
      if (e.message === STRINGS.common.error400Template) {
        setError(STRINGS.common.error400TextRead);
      }
      setError(STRINGS.common.error404Text);
    });
};

export const fetchMoreVisitsUnscheduled = async (
  url,
  setError,
  saveMoreVisits,
  logoutHandler,
  token,
) => {
  const noHostUrl = url?.split('://')[1];
  const correctUrl = noHostUrl?.substring(noHostUrl?.indexOf('/'));
  await apiCaller
    .get(correctUrl, {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    })
    .then((response) => {
      if (response.data !== undefined) {
        setError(null);
        saveMoreVisits(response.data);
      } else {
        setError(STRINGS.common.error404Text);
      }
    })
    .catch((e) => {
      if (e.message === STRINGS.common.errorMissingCredentials) {
        logoutHandler();
      }
      if (e.message === STRINGS.common.error400Template) {
        setError(STRINGS.common.error400TextRead);
      }
      setError(STRINGS.common.error404Text);
    });
};
